import { clearAuthData } from './authStorage';

/**
 * Clear all user-related data from localStorage.
 * Clears auth tokens, identity caches, and the Zustand persisted store
 * so stale data is not rehydrated on next login.
 */
const clearUserData = (): void => {
  // Clear auth tokens, session data, and per-user identity cache
  clearAuthData();

  // Clear selectedLocale set by the Sidebar component
  localStorage.removeItem('selectedLocale');

  // Clear the entire Zustand persisted store
  localStorage.removeItem('theme-storage');
};

/**
 * Logout handler that can be used anywhere in the app
 *
 * Usage:
 * ```typescript
 * import { useAuth0 } from '@auth0/auth0-react';
 * import { handleLogout } from '@lucid/auth';
 *
 * const MyComponent = () => {
 *   const { logout } = useAuth0();
 *
 *   return (
 *     <button onClick={() => handleLogout(logout)}>
 *       Logout
 *     </button>
 *   );
 * };
 * ```
 */
export const handleLogout = (
  auth0Logout: (options?: { logoutParams?: { returnTo?: string } }) => void,
  returnUrl?: string
): void => {
  // Clear all auth + user identity data before redirect
  clearUserData();

  // Logout from Auth0 and redirect to login page with logout state
  const logoutUrl = returnUrl || `${window.location.origin}/login?loggedOut=true`;

  auth0Logout({
    logoutParams: {
      returnTo: logoutUrl,
    },
  });
};
